import {get} from '@/lib/request'

function messageSubjectIndexPath() {
  return `/wp/v2/message_subjects`
}

export function listMessageSubjects(params = {}) {
  return get(messageSubjectIndexPath(), params)
}
